import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { apiDeleteQuoteRelatedFiles, apiGetValidationDocument, convertTimeToServerStoredTimeData, openUrlWithNewWindow } from '@jove-frontend/uikit';
import { apiGetQuoteSignatureDocumentDetailInfo } from '../api/documentsApi';
export var useFileDocument = function useFileDocument() {
  var _useState = useState(false),
      documentLoading = _useState[0],
      setDocumentLoading = _useState[1];

  var _useState2 = useState(false),
      deleteDocumentLoading = _useState2[0],
      setDeleteDocumentLoading = _useState2[1];
  /**
   * requests
   */


  var requestDocumentDetailInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var _res$data;

      var params, _yield$apiGetQuoteSig, _yield$apiGetQuoteSig2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                quote_document_id: id
              };
              setDocumentLoading(true);
              _context.next = 4;
              return apiGetQuoteSignatureDocumentDetailInfo(params);

            case 4:
              _yield$apiGetQuoteSig = _context.sent;
              _yield$apiGetQuoteSig2 = _slicedToArray(_yield$apiGetQuoteSig, 1);
              res = _yield$apiGetQuoteSig2[0];
              setDocumentLoading(false);
              return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                url: res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.download_url
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestDocumentDetailInfo(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var requestValidationDocumentDetailInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, info) {
      var _yield$apiGetValidati, _yield$apiGetValidati2, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setDocumentLoading(true);
              _context2.next = 3;
              return apiGetValidationDocument(id, info);

            case 3:
              _yield$apiGetValidati = _context2.sent;
              _yield$apiGetValidati2 = _slicedToArray(_yield$apiGetValidati, 1);
              res = _yield$apiGetValidati2[0];
              setDocumentLoading(false);
              return _context2.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, res), res === null || res === void 0 ? void 0 : res.validation_document), {}, {
                url: res === null || res === void 0 ? void 0 : res.download_url
              }));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestValidationDocumentDetailInfo(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var viewDocumentFileWithDocumentId = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(info) {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return requestValidationDocumentDetailInfo(info.validationDocumentId, info);

            case 2:
              res = _context3.sent;

              if (res !== null && res !== void 0 && res.url) {
                openUrlWithNewWindow(res.url);
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function viewDocumentFileWithDocumentId(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var requestDeleteQuoteDocumentFile = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
      var params, _yield$apiDeleteQuote, _yield$apiDeleteQuote2, res;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              params = {
                quote_document_id: data === null || data === void 0 ? void 0 : data.id,
                cancelled_at: convertTimeToServerStoredTimeData(new Date())
              };
              setDeleteDocumentLoading(true);
              _context4.next = 4;
              return apiDeleteQuoteRelatedFiles(params);

            case 4:
              _yield$apiDeleteQuote = _context4.sent;
              _yield$apiDeleteQuote2 = _slicedToArray(_yield$apiDeleteQuote, 1);
              res = _yield$apiDeleteQuote2[0];
              setDeleteDocumentLoading(false);
              return _context4.abrupt("return", res);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function requestDeleteQuoteDocumentFile(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    requestDocumentDetailInfo: requestDocumentDetailInfo,
    documentLoading: documentLoading,
    requestValidationDocumentDetailInfo: requestValidationDocumentDetailInfo,
    viewDocumentFileWithDocumentId: viewDocumentFileWithDocumentId,
    requestDeleteQuoteDocumentFile: requestDeleteQuoteDocumentFile,
    deleteDocumentLoading: deleteDocumentLoading
  };
};